<!-- =========================================================================================
    File Name: ChatContact.vue
    Description: Chat contact - single component for chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="chat__contact flex items-center px-2 pt-4 pb-2" :class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}">
        <div class="contact__avatar mr-1">
            <vs-chip :color="contact.color_code" class="mychip">

            </vs-chip>
            <!-- <vs-avatar v-if="contact.image" class="border-2 border-solid border-white" :src="img_cdn+contact.image" size="42px" />
            <vs-avatar v-else class="border-2 border-solid border-white" size="42px" /> -->
        </div>
        <div class="contact__container w-full flex items-center justify-between overflow-hidden">
            <div class="contact__info flex flex-col truncate w-5/6">
                <h5 class="font-semibold" :class="{'text-white': isActiveChatUser}">{{ contact.name }}  <span  style="font-size:12px;font-weight: normal;font-style: italic">{{contact.location.name}}</span></h5>
                <span class="truncate" v-if="contact.message">{{contact.message.message}}</span>
            </div>
            <div class="chat__contact__meta flex self-start flex-col items-end w-1/6">
                <span class="whitespace-no-wrap" v-if="contact.message">{{ contact.message.created_at | formatDate }}</span>
                
                <vs-chip class="number" color="primary"  v-if="contact.counter > 0 ">{{ contact.counter }}</vs-chip>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import {
  PROGRAM_LAST_MSG,
  GET_UNREAD_MESSAGE,
} from '@/graphql'
export default {
  props: {
    contact          : { type: Object,  required: true },
    isActiveChatUser : { type: Boolean },
    lastMessaged     : { type: String,  default : '' },
    showLastMsg      : { type: Boolean, default: false },
    unseenMsg        : { type: Number,  default : 0 }
  },
   computed: {
     msgCounter(){
       return this.msgCount
    },
   },
  watch:{
    isActiveChatUser (val) {
      if (val) {
        this.contact.counter = 0
      }
    }

  },
  filters: {
    formatDate (value) {
      if (value) {
        return   moment(String(value)).format('ll').slice(0, 6).trim()
        
      }
    }
  },
  data () {
    return {
      img_cdn: '',
      last_msg:{'message':' ', 'created_at':''},
       msgCount:0,
    }
  },
  mounted () {
    // Listen for the 'NewMessageNotification' event in the 'synchronized' private channel
    this.$echo.channel('synchronized').listen('NewMessageNotification', (payload) => {
      if (payload) {
        if (payload.type === 'program') {
          if (this.contact.id === payload.message.program_id && this.meID !== payload.message.user_id) {
            this.contact.counter++
            this.contact.message.message = payload.message.message
            this.contact.message.created_at = payload.message.created_at
          }
        }
      }
    })
  },
  created () {
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    // this.$apollo
    //   .mutate({
    //     mutation:PROGRAM_LAST_MSG,
    //     variables: {
    //       program_id: this.contact.id
    //     }
    //   })
    //   .then(response => {
    //     if (response.data.program_last_msg) {
    //       this.last_msg = response.data.program_last_msg
    //     }
    //   }).catch(error => {
    //     console.log(error)
    //   })
    //     let userId= localStorage.getItem('userId');
    //     this.$apollo
    //       .mutate({
    //         mutation: GET_UNREAD_MESSAGE,
    //         variables: {
    //           student_id: this.contact.id,
    //           user_id:userId,
    //           type:'program'
    //         }
    //       })
    //       .then(response => {
    //         // this.contact.count = response.data.getUnreadChat.counter
    //         this.msgCount = response.data.getUnreadChat.counter

    //       }).catch(error => {
    //         console.log(error)
    //       })
  }
}

</script>
<style >
.mychip{
    min-height: 32px;
    min-width: 32px;
    font-size: .8rem;
}
</style>

